<template>
  <div class="project">
    <ProjectContent :projectData="projectData"></ProjectContent>
  </div>
</template>

<script>
import ProjectContent from '@/components/ProjectContent.vue'

export default {
  name: 'Project',
  components: {
    ProjectContent
  },
  data: function () {
    return {
      projectURL: this.$route.params.projectURL,
      projectData: {},
      projects: []
    }
  },
  created: function () {
    fetch('https://adminportfolio.emarketingbr.com.br/projects')
      .then((resp) => resp.json())
      .then((data) => {
        this.projects = data
        let pUrl = this.projectURL
        let project = this.projects.filter((p) => {
          return p.url === pUrl
        })
        if (project.length < 1) {
          this.$router.go(-1)
        } else {
          this.projectData = project[0]
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {}
}
</script>

<style scoped lang="scss">
</style>
